<div class="row">
    <div tabindex="0" class="col-12" [innerHTML]="getHtml(slice.primary?.text, vehicle) | safeHtml"></div>
</div>
